import { Link } from 'react-router-dom'
import logo from '../assets/rock-reference-logo.png'
export const Header = () => {
  return (
    <header className="App-header">
      <Link to='/'>
        <img style={{ float: 'left' }} src={logo} alt="bat and rock" />
      </Link>
    </header>
  )
}
